// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"393a3467","952":"251013af"}[chunkId] + ".chunk.js";
};